import {
  Modal as HeroUIModal,
  ModalBody as HeroUIModalBody,
  ModalContent as HeroUIModalContent,
  ModalFooter as HeroUIModalFooter,
  ModalHeader as HeroUIModalHeader,
  ModalProps as HeroUIModalProps,
} from "@heroui/react";
import { FocusScope } from "@react-aria/focus";
import { useControlledState } from "@react-stately/utils";
import { useCallback } from "react";

export type ModalProps = Omit<
  HeroUIModalProps,
  "children" | "isOpen" | "onClose"
> & {
  children?: React.ReactNode;
  isOpen: boolean;
  onClose?: () => void;
  hideCloseButton?: boolean;
};

const Modal = ({ children, isOpen, onClose, ...props }: ModalProps) => {
  const [open, setOpen] = useControlledState(isOpen, false, onClose);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <HeroUIModal
      classNames={{
        backdrop: "bg-black bg-opacity-35 z-modal",
        closeButton: "data-[focus-visible=true]:outline-offset-1",
        wrapper: "z-modal",
      }}
      isOpen={open}
      placement="center"
      radius="sm"
      scrollBehavior="inside"
      shadow="md"
      onClose={handleClose}
      {...props}
    >
      <FocusScope contain restoreFocus>
        {children}
      </FocusScope>
    </HeroUIModal>
  );
};

Modal.displayName = "RecareUI.Modal";

export {
  Modal,
  HeroUIModalBody as ModalBody,
  HeroUIModalContent as ModalContent,
  HeroUIModalFooter as ModalFooter,
  HeroUIModalHeader as ModalHeader,
};
